// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import * as angular from 'angular';
import { Captcha } from '../../../components/captcha/captcha.model';
import { SpAlert } from '../../../components/sp-alert/sp-alert.model';

/** @ngInject */
export function Controller($scope, $state, $timeout, $stateParams, SmsGatewaysService, SmsUserOtp) {
	this.$onInit = () => {		
	    if ($stateParams.showResetPinSuccessMessage){
	    	$timeout(1000).then(() => $scope.topLevelMessage = new SpAlert('success', 'pin.reset.pin_code_sent_success') );	        
	    }
	};
	$scope.smsUserOtpFlag = true;
    $scope.smsUserCompanyOtpFlag = false;
    $scope.showCaptcha = false;
    
    const captcha = $scope.captcha = new Captcha({
        isVisible: () => $scope.showCaptcha
    });

    $scope.smsUserOtp = {
        "mobilePhoneNumber" : null,
        "pin" : null,
        "smsCompanies" : null,
        "showCaptcha" : false,
        "captchaResponse" : null
    };
    $scope.generateOtp = function() {
        localStorage.setItem('preferred-sms-gateway', $scope.smsUserOtp.smsGatewayIdentifier);
        $scope.smsUserOtp.captchaResponse = captcha.response;
        SmsUserOtp.save($scope.smsUserOtp, function(response, responseHeaders) {
            var status = responseHeaders("x-sp-status");
            if (status == 307) {
                $scope.smsCompanyItems = response.smsCompanies;
                $scope.smsUserOtpFlag = false;
                $scope.smsUserCompanyOtpFlag = true;               
            } else {
                $scope.smsUserOtp.pin = null;
                $scope.topLevelMessage = new SpAlert('success', 'sms.otp.messages.sms_otp_send');
            }
            $scope.showCaptcha = false;
            captcha.reset();
        }, function(response) {
            var status = response.status;
            captcha.reset();
            if (angular.isDefined(response.data.serviceErrorCode)
                    && (response.data.serviceErrorCode.toString() == 'ERR_101407' || response.data.serviceErrorCode.toString() == 'ERR_101409')) {
                $scope.smsUserOtp.showCaptcha = true;
                $scope.showCaptcha = true;
                $scope.topLevelMessage = new SpAlert('danger', response.data.message);
            } else if (status == 412) {
                const key = 'registration.company.messages.invalid_captcha';
                $scope.topLevelMessage = new SpAlert('danger', key);
            } else {
                $scope.topLevelMessage = new SpAlert('danger', response.data.message);
            }
        });

    };

    $scope.generateCompanyOtp = function(id) {
        SmsUserOtp.save({
            id : id
        }, $scope.smsUserOtp, function(response) {
            $scope.smsUserOtpFlag = true;
            $scope.smsUserCompanyOtpFlag = false;
            $scope.smsUserOtp.pin = null;
            $scope.showCaptcha = false;
            captcha.reset();
            $scope.topLevelMessage = new SpAlert('success', 'sms.otp.messages.sms_otp_send')
        }, function(response) {
            $scope.topLevelMessage = new SpAlert('danger', response.data.message);
        });

    };

    $scope.cancel = function() {
        $scope.smsUserOtpFlag = true;
        $scope.smsUserCompanyOtpFlag = false;
        $scope.showCaptcha = false;
        captcha.reset();
        $scope.smsUserOtp = {
            "mobilePhoneNumber" : null,
            "pin" : null,
            "smsCompanies" : null,
            "showCaptcha" : false,
            "captchaResponse" : null
        };
    };

    $scope.$watch('smsGenerateOtpForm.$error.err', (error) => {
        if (error || !$scope.smsUserOtp.mobilePhoneNumber) {
            $scope.gateways = [];
            $scope.smsUserOtp.smsGatewayIdentifier = undefined;
        } else {
            SmsGatewaysService
                .getSmsGatewayList($scope.smsUserOtp.mobilePhoneNumber)
                .then((gateways) => {
                    $scope.gateways = gateways;
                    const preferredGateway = localStorage.getItem('preferred-sms-gateway');
                    if (gateways.includes(preferredGateway)) {
                        $scope.smsUserOtp.smsGatewayIdentifier = preferredGateway;
                    } else {
                        $scope.smsUserOtp.smsGatewayIdentifier = gateways[0];
                    }
                });
        }
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/sms-user-otp/sms-user-otp.controller.js